import { Pipe, PipeTransform } from '@angular/core'
import { environment } from '@app/env'
import correctUrlFactory from '@fieldcontrol/correct-url'
import { IsBase64Pipe } from '@pipes/is-base64/is-base64.pipe'

@Pipe({
    name: 'correctUrl',
    standalone: false
})
export class CorrectUrlPipe implements PipeTransform {
  public constructor (
    private readonly isBase64Pipe: IsBase64Pipe
  ) { }

  public transform(url: string | null | undefined, whenNullOrEmpty?: string): string | null {
    if (url === undefined) {
      url = null
    }

    if (this.isBase64Pipe.isBase64(url)) {
      return url
    }

    const correctUrl = correctUrlFactory({
      prefix: environment.FILE_PREFIX,
      whenNullOrEmpty: whenNullOrEmpty || 'assets/placeholder.png'
    })

    return correctUrl(url)
  }
}
